export { default as ArrowDownIcon } from './ArrowDown';
export { default as ArrowLeftIcon } from './ArrowLeft';
export { default as ArrowRightIcon } from './ArrowRight';
export { default as BarcodetIcon } from './Barcode';
export { default as CheckIcon } from './Check';
export { default as CircularCheckIcon } from './CircularCheck';
export { default as CirclePlusIcon } from './CirclePlus';
export { default as CloseIcon } from './CloseIcon';
export { default as CleanIcon } from './Clean';
export { default as DashboardIcon } from './Dashboard';
export { default as ErrorIcon } from './ErrorIcon';
export { default as EscaladaBonusIcon } from './EscaladaBonus';
export { default as ExtratoIcon } from './Extrato';
export { default as ExpressIcon } from './Express';
export { default as FidelizeIcon } from './Fidelize';
export { default as FileErrorIcon } from './FileErrorIcon';
export { default as FileUploadIcon } from './FileUploadIcon';
export { default as FileCompletedIcon } from './FileCompletedIcon';
export { default as HomeIcon } from './Home';
export { default as HelpIcon } from './Help';
export { default as KeyIcon } from './Key';
export { default as LetterIcon } from './Letter';
export { default as PaperIcon } from './Paper';
export { default as PencilIcon } from './Pencil';
export { default as SearchIcon } from './Search';
export { default as TooltipWarningIcon } from './TooltipWarning';
export { default as UploadIcon } from './UploadIcon';
export { default as PersonIcon } from './Person';
export { default as ReportIcon } from './Report';
export { default as VisibilityIcon } from './Visibility';
export { default as VisibilityOffIcon } from './VisibilityOff';
export { default as WarningIcon } from './WarningIcon';
export { default as CircularWarningIcon } from './CircularWarning';
export { default as ActivityIcon } from './Activity';
export { default as AlertCircleIcon } from './AlertCircle';
export { default as Star } from './Star';